// @flow

import type { FormInstance } from 'antd/es/form';
import {Button, message, Form, Input, Select, Table, DatePicker, Tag} from 'antd';
import React, {useEffect, useState} from 'react';
import {
 requestUserList, requestGroupList,
} from '../../../axios/http';
import { useNavigate } from 'react-router-dom';
import type {ColumnsType} from "antd/es/table";
import moment from "moment";

type Props = {
  username: string;
};
export const Group = (props: Props) => {
  let [data, setData] = useState<DataType[]>([]);
  let navigate = useNavigate();
  const { RangePicker } = DatePicker;
  const [selectedDates, setSelectedDates] = useState<number[]>([]);

  interface DataType {
    id: number;                 // 群组 ID
    name: string;               // 群组名称
    description: string;        // 群组描述
    default_group: boolean;     // 是否为默认群组
    owner: string;              // 群组所有者名称
    owner_id: number;           // 群组所有者 ID
    create_time: number;        // 创建时间，时间戳
  };

  const columns: ColumnsType<DataType> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: text => <a>{text}</a>,
    },
    {
      title: 'Owner',
      dataIndex: 'owner',
      key: 'owner',
    },
    {
      title: 'owner Id',
      dataIndex: 'owner_id',
      key: 'owner_id',
    },
    {
      title: 'is default group',
      dataIndex: 'default_group',
      key: 'default_group',
      render: text => <div>
        {text ? <Tag color={'green'} key={text}>
          yes
        </Tag>:<Tag color={'red'} key={text}>
          no
        </Tag>}
      </div>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',

    },
    {
      title: 'create_time',
      dataIndex: 'create_time',
      key: 'create_time',
      render: text => <a>{text&&moment(text).format('YYYY-MM-DD HH:mm:ss')}</a>,
    },

  ];

  async function getGroupList(){
    let result = await requestGroupList()
    setData(result.data.users)
  }

  useEffect(() => {
    getGroupList()
  }, []);

  return (
        <div>
          <Table columns={columns} dataSource={data}/>
        </div>
  );
};
